import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

const socials = [
  { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/1jayatk" },
  { Icon: Facebook, label: "Facebook", href: "https://www.facebook.com/share/1LHseGzdjw/?mibextid=wwXIfr" },
];

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0A0A0A]" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
        <div>
          <div className="mb-4">
            <img src="/logo-jayatk.png" alt="Jay Atk" className="h-11 w-auto" />
          </div>
          <p className="text-[#A19D94] max-w-sm">Jay Atk Events. Good music, good people, good vibes — every event, all year.</p>
        </div>

        <div className="flex items-center gap-5">
          {socials.map(({ Icon, label, href }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer"
              data-testid={`social-${label.toLowerCase()}`}
              className="w-11 h-11 border border-white/15 flex items-center justify-center text-[#A19D94] hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-colors duration-300" aria-label={label}>
              <Icon className="w-4 h-4" />
            </a>
          ))}
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.2em] text-[#5c5850]">
        <span>© {new Date().getFullYear()} Jay Atk Events</span>
        <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[#D4AF37] transition-colors">Admin</Link>
      </div>
    </div>
  </footer>
);
